<div class="pie-chart kpi-pie-chart-element mat-card">
  <div class="main-container" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="chart-container">
      <div *ngIf="isDataSetLoaded$ | async; else loading">
        <div [chart]="currentChart"></div>
      </div>
      <ng-template #loading>
        <div [chart]="placeholderChart" syncPulse></div>
      </ng-template>
    </div>
    <div class="metrics-wrapper">
      <ng-container *ngIf="isDataSetLoaded$ | async; else metricsLoading">
        <div class="metrics-container">
          <div class="metric-box">
            <div class="metric-title">
              {{ firstMetricTitle }}
            </div>
            <div class="metric-content">
              <b class="metric-value">
                {{ firstMetricLabel }}
              </b>
              <i
                [ngClass]="[
                  getTrendArrowIconClass(firstMetricValuePOPNum),
                  getTrendIconColor(firstMetricValuePOPNum)
                ]"
              ></i>
            </div>
            <div class="subtitle">
              <span class="subtitle-label">Prev. Period:</span>
              <span class="subtitle-value">{{ firstMetricValuePreviousPeriod }}</span>
            </div>
          </div>
          <div class="metric-box">
            <div class="metric-title">
              {{ secondMetricTitle }}
            </div>
            <div class="metric-content">
              <b class="metric-value">
                {{ secondMetricLabel }}
              </b>
              <i
                [ngClass]="[
                  getTrendArrowIconClass(secondMetricValuePOPNum),
                  getTrendIconColor(secondMetricValuePOPNum)
                ]"
              ></i>
            </div>
            <div class="subtitle">
              <span class="subtitle-label">Prev. Period:</span>
              <span class="subtitle-value">{{ secondMetricValuePreviousPeriod }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #metricsLoading>
        <div class="metrics-container">
          <div class="metric-box">
            <div class="metric-content">
              <div syncPulse
                style="height: 32px; width: 90%; background-color: #e0e0e0; border-radius: 4px; margin-right: 10px;"></div>
              <div syncPulse style="width: 24px; height: 24px; background-color: #e0e0e0; border-radius: 50%;"></div>
            </div>
            <div class="subtitle" style="margin-top: 8px;">
              <div syncPulse style="height: 20px; width: 70%; background-color: #e0e0e0; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="metric-box">
            <div class="metric-content">
              <div syncPulse
                style="height: 32px; width: 90%; background-color: #e0e0e0; border-radius: 4px; margin-right: 10px;"></div>
              <div syncPulse style="width: 24px; height: 24px; background-color: #e0e0e0; border-radius: 50%;"></div>
            </div>
            <div class="subtitle" style="margin-top: 8px;">
              <div syncPulse style="height: 20px; width: 70%; background-color: #e0e0e0; border-radius: 4px;"></div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
